import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import Svg from '@bibliocommons/svg';
import { bibShape, holdItemShape } from '@bibliocommons/bc-prop-types';
import { CancelHoldButtonContainer } from './CancelHoldButton';
import { PhysicalHoldButtonContainer } from './PhysicalHoldButton';
import { DigitalAccessButtonContainer } from './DigitalAccessButton';

import './TitleTransactionButton.scss';

function renderPlaceholder() {
  return (
    <Svg className="button-placeholder" width="120" height="40" viewBox="0 0 120 40" preserveAspectRatio="none">
      <rect width="120" height="40" rx="3" />
    </Svg>
  );
}

export class TitleTransactionButton extends React.PureComponent {
  renderTransactionButton() {
    const { bib, holdItem } = this.props;
    const hasItemLevelHoldableItems = bib.getIn(['policy', 'itemLevelHoldableItems']);
    const materialType = bib.getIn(['policy', 'materialType']);
    const isDigitalBib = materialType === 'DIGITAL';
    const isDigitalHoldReady = isDigitalBib && holdItem && holdItem.get('status') === 'READY_FOR_PICKUP';
    const canPlaceItemLevelHolds = hasItemLevelHoldableItems && holdItem && holdItem.get('itemId');

    if (holdItem && !isDigitalHoldReady && !canPlaceItemLevelHolds) {
      return <CancelHoldButtonContainer {...this.props} />;
    }

    if (isDigitalBib) {
      return <DigitalAccessButtonContainer {...this.props} />;
    }

    return <PhysicalHoldButtonContainer {...this.props} />;
  }

  render() {
    const { bib, block, isLoading } = this.props;

    if (bib.getIn(['policy', 'holdable'])) {
      const classNames = cn('cp-title-transaction-button', {
        'title-transaction-button--block': block
      });

      return <div className={classNames}>{isLoading ? renderPlaceholder() : this.renderTransactionButton()}</div>;
    }

    return null;
  }
}

TitleTransactionButton.propTypes = {
  bib: bibShape.isRequired,
  block: PropTypes.bool,
  isLoading: PropTypes.bool,
  holdItem: holdItemShape
};

export default TitleTransactionButton;
